import React from 'react';
import { cn } from '@/lib/utils';

type LegalTableProps = {
  headers: string[];
  rows: React.ReactNode[][];
  className?: string;
};

export function LegalTable({ headers, rows, className }: LegalTableProps) {
  const lastRowIndex = rows.length - 1;

  return (
    <div className={cn('rounded-[10px] border border-[#E5E5E5] overflow-hidden', className)}>
      <div className="overflow-x-auto">
        <table className="w-full min-w-full text-sm md:text-base md:leading-6 text-left border-separate border-spacing-0">
          <thead>
            <tr className="bg-gray-50">
              {headers.map((header, headerIndex) => (
                <th
                  key={header}
                  className={cn(
                    'py-3 px-4 font-semibold text-foreground border-[#E5E5E5]',
                    'border-b border-r last:border-r-0',
                    headerIndex === 0 && 'rounded-tl-[10px]',
                    headerIndex === headers.length - 1 && 'rounded-tr-[10px]'
                  )}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex} className="align-top">
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className={cn(
                      'py-3 px-4 text-gray-600 border-[#E5E5E5]',
                      'border-b border-r last:border-r-0',
                      rowIndex === lastRowIndex && 'border-b-0',
                      rowIndex === lastRowIndex && cellIndex === 0 && 'rounded-bl-[10px]',
                      rowIndex === lastRowIndex && cellIndex === row.length - 1 && 'rounded-br-[10px]'
                    )}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
